import { Button } from 'antd';
import styled from 'styled-components';

export const ProductCardImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ImageNavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 8px;
`;

export const NavigationButton = styled(Button)`
  && {
    font-size: 8px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    box-shadow: none;

    &:hover,
    &:focus {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  overflow: hidden;
  flex: 1;
  max-width: 248px;
  max-height: 248px;
`;

export const ImageCounter = styled.div`
  position: absolute;
  bottom: 4px;
  right: 4px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 9px;
  padding: 1px 4px;
  border-radius: 3px;
  z-index: 2;
`;

export const ImageLabel = styled.div`
  font-size: 11px;
  color: #666;
  text-align: center;
  margin-top: 4px;
  padding: 2px 4px;
`;

export const LkpImagesButton = styled.button`
  position: absolute;
  bottom: 2px;
  left: 2px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 3px;
  padding: 2px 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  &:focus {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
  }

  .anticon {
    font-size: 16px;
    color: #ff8c00;
  }
`;

export const RealPhotosLegend = styled.div`
  margin-left: 5px;
  display: flex;
  align-items: center;
  align-self: flex-start;
  max-width: calc(100% - 5px);
  gap: 4px;
  font-size: 11px;
  color: #ff8c00;
  background-color: #fff7e6;
  border: 1px solid #ff8c00;
  border-radius: 3px;
  padding: 2px 6px;
  margin-top: 4px;
  line-height: 1.3;

  .anticon {
    font-size: 12px;
    color: #ff8c00;
    flex-shrink: 0;
  }
`;
